// Note: co-locating this in routes/index.tsx causes an error where this const is being referenced before it is defined
/** The paths to platform app SPA "pages". Suffixed after movingworlds.org/platform */
export const ROUTES = {
  HOME: '/',
  SOCIAL_ENTERPRISES: '/social-enterprises',
  PROFESSIONALS: '/professionals',
  DASHBOARD: '/dashboard',
  SIGN_UP: '/sign-up',
  SIGN_IN: '/sign-in',
  AUTH: '/auth',
  PROFILE: '/profile',
  APPLICATION_START: '/application-start',
  EMAIL_VERIFICATION: '/email-verification',
  PASSWORD_RESET_EMAIL_VERIFICATION: '/password-reset-email-verification',
  FORGOT_PASSWORD: '/forgot-password',
  UPDATE_PASSWORD: '/update-password',
  CHANGE_PASSWORD: '/change-password',
  UPDATE_YOUR_EMAIL: '/update-your-email',
  LOGIN: '/login',
  LOGOUT: '/logout',
  WELCOME_LOGIN: '/welcome-login/:partner',
  ERROR: '/error',
  MY_PROJECTS: '/my-projects',
  HEALTHCHECK: '/healthcheck',
  ADMIN: '/admin',
  COMMUNITY: '/community',
  JOB_OPENINGS: '/job-openings',
  EVENTS: '/events',
  FUNDING_OPPORTUNITIES: '/funding-opportunities',
  COMMUNITY_WINS: '/community-wins',
  BUSINESS_CHALLENGES: '/business-challenges',
  BUSINESS_CHALLENGES_ONE: '/one',
  BUSINESS_CHALLENGES_TWO: '/two',
  BUSINESS_CHALLENGES_THREE: '/three',
  BUSINESS_CHALLENGES_SUBMITTING: '/submitting',
  BUSINESS_CHALLENGES_SUCCESS: '/success',
  BUSINESS_CHALLENGES_ERROR: '/error',
  INVITE_ORG_COLLEAGUE: '/invite-colleague',
} as const;

// TODO: Rework our route constants to make this available without creating a new const
export const SIGN_UP_HREF = `/platform${ROUTES.AUTH}${ROUTES.SIGN_UP}`;
